import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

import { ConfigService } from '../services/config/config.service';
import { NativeBridgeService, NativeAppPlatform } from '../services/native-bridge/native-bridge.service';
import { StorageService } from '../services/storage/storage.service';

const containsUrl = (urlsToCheck: string[] = [], url: string): boolean =>
  urlsToCheck.some((urlToCheck: string) => url.includes(urlToCheck));

const CLIENT_ID_KEY = 'X-Client-Id';
const SESSION_ID_KEY = 'X-Session-Id';

@Injectable({
  providedIn: 'root',
})
export class DapiHeadersInterceptor implements HttpInterceptor {
  private configService = inject(ConfigService);
  private storageService = inject(StorageService);
  private nativeBridgeService = inject(NativeBridgeService);

  private clientId: string;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!containsUrl(this.configService.useDapiUATForUrls, req.url)) {
      return next.handle(req);
    }

    if (!this.storageService.SESSION.get(SESSION_ID_KEY)) {
      this.storageService.SESSION.set(SESSION_ID_KEY, uuid());
    }

    if (!this.clientId) {
      this.clientId = this.getClientId();
    }

    const request: HttpRequest<unknown> = req.clone({
      headers: req.headers
        .set(CLIENT_ID_KEY, this.clientId)
        .set(SESSION_ID_KEY, this.storageService.SESSION.get(SESSION_ID_KEY) ?? ''),
    });
    return next.handle(request);
  }

  private getClientId(): string {
    switch (this.nativeBridgeService.nativeAppPlatform) {
      case NativeAppPlatform.ANDROID:
        return 'MOBILEAPP_ANDROID';
      case NativeAppPlatform.IOS:
        return 'MOBILEAPP_IOS';
      case NativeAppPlatform.RN_ANDROID:
        return 'FINNAIR_APP_ANDROID';
      case NativeAppPlatform.RN_IOS:
        return 'FINNAIR_APP_IOS';
      default:
        return 'FCOM';
    }
  }
}
